import styled from '@emotion/styled';

export const IconsContainer = styled.div`
  unicode-bidi: bidi-override;
  position: relative;
  font-size: 16px;
  height: 20px;
  padding: 0;
  width: fit-content;
`;

export const Icon = styled.img`
  display: inline-block !important;
  &:not(:last-child) {
    margin-right: 8px;
  }
`;

export const EmptyContainer = styled.div`
  display: block;
  z-index: 0;
`;

export const FilledContainer = styled.div<{ amount: number; maxAmount: number }>`
  width: ${(props) => props.amount * (100 / props.maxAmount)}%;
  position: absolute;
  z-index: 1;
  display: block;
  top: 0;
  left: 0;
  overflow: hidden;
  height: inherit;
  white-space: nowrap;
`;
